if (!customElements.get('alhaq-add-review-cart')) {
  customElements.define(
    'alhaq-add-review-cart',
    class AlhaqAddReviewCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-alhaq-add-review-cart]');
        this.form = document.getElementById(this.dataset.productFormId);
        this.productForm = this.closest('product-form');
        this.primaryButton = this.productForm?.querySelector('.product-form__submit');
        this.label = this.button?.querySelector('[data-alhaq-add-review-cart-label]');
        this.spinner = this.button?.querySelector('.loading__spinner');
        this.defaultLabel = this.label?.textContent.trim() || 'Add & review cart';
        this.processing = false;

        if (!this.button || !this.form || !this.primaryButton) {
          this.button?.setAttribute('disabled', 'disabled');
          return;
        }

        this.onClick = this.handleClick.bind(this);
        this.button.addEventListener('click', this.onClick);

        this.primaryButtonObserver = new MutationObserver(() => this.syncAvailability());
        this.primaryButtonObserver.observe(this.primaryButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
        });

        this.syncAvailability();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.primaryButtonObserver?.disconnect();
      }

      syncAvailability() {
        if (!this.button || this.processing) return;

        const unavailable =
          this.primaryButton?.disabled || this.primaryButton?.getAttribute('aria-disabled') === 'true';
        this.button.toggleAttribute('disabled', Boolean(unavailable));
      }

      setLoading(loading) {
        this.processing = loading;
        this.button.classList.toggle('loading', loading);
        this.button.toggleAttribute('disabled', loading);
        this.button.setAttribute('aria-disabled', loading ? 'true' : 'false');
        this.spinner?.classList.toggle('hidden', !loading);

        if (this.label) {
          this.label.textContent = loading ? this.button.dataset.loadingLabel || 'Adding…' : this.defaultLabel;
        }

        if (!loading) this.syncAvailability();
      }

      clearError() {
        const wrapper = this.productForm?.querySelector('.product-form__error-message-wrapper');
        wrapper?.setAttribute('hidden', 'hidden');
      }

      showError(message) {
        const wrapper = this.productForm?.querySelector('.product-form__error-message-wrapper');
        const errorMessage = wrapper?.querySelector('.product-form__error-message');

        if (!wrapper || !errorMessage) return;
        errorMessage.textContent = message;
        wrapper.removeAttribute('hidden');
      }

      async handleClick() {
        if (this.processing || this.button.disabled) return;

        this.clearError();

        if (!this.form.reportValidity()) return;

        const variantInput = this.form.querySelector('[name="id"]');
        if (!variantInput || variantInput.disabled || !variantInput.value) {
          this.showError(window.variantStrings?.unavailable || 'This product is unavailable.');
          this.syncAvailability();
          return;
        }

        this.setLoading(true);

        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: new FormData(this.form),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add this product to the cart.');
          }

          window.location.assign(window.routes.cart_url);
        } catch (error) {
          this.showError(error.message || 'Unable to add this product to the cart.');
          this.setLoading(false);
        }
      }
    }
  );
}
